module.exports = __webpack_public_path__ + "img/gobierno.036cace8.jpeg";